// @flow
import React from 'react';
import Checkbox from 'material-ui/Checkbox';

type Props = {
    checked: boolean,
    onChange: () => any
};

const NotificationSettingsCheckbox = ({ checked, onChange }: Props) => {
    return (
        <Checkbox
            classes={{
                root: 'primary-checkbox',
                checked: 'primary-checkbox-checked'
            }}
            checked={checked}
            onChange={() => onChange(!checked)}
        />
    );
};

export default NotificationSettingsCheckbox;
